import {CssBaseline, withStyles} from '@material-ui/core';
import * as React from 'react';
import TranslateNew from '@translate/TranslateNew';
import {FullScreenCardStyle as styles} from './FullScreenCard.style';




interface IProps {
    classes: any;
    sideElement?: JSX.Element;
}

const tn: TranslateNew = TranslateNew.getInstance();

class FullScreenCard extends React.Component<IProps> {

    public render() {
        const classes = this.props.classes;
        return (
            <React.Fragment>
                <CssBaseline/>
                <div className={classes.signupPage}>
                    <div className={classes.background}/>
                    <div className={classes.signupCard} id="top-of-card">
                        <div className={classes.logoContainer}>
                            {this.props.sideElement}
                        </div>
                        {this.props.children}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}


export default (withStyles(styles)(FullScreenCard));




// WEBPACK FOOTER //
// ./src/components/common/fullscreencard/FullScreenCard.tsx